export default "__VITE_ASSET__Bx697PbW__$_?no-inline__"